import {
  Card,
  CardContent,
  Typography,
  List,
  ListItem,
  Box,
} from "@mui/material";
import useDarkMode from "./useDarkMode";
import { Helmet } from "react-helmet-async";

const AdminDashboard = () => {
  useDarkMode();
  return (
    <>
      <Helmet>
        <title>AKAAL KIDS - Admin Panel | Dashboard</title>
      </Helmet>
      <Box sx={{ display: "flex", justifyContent: "flex-start", mt: 4 }}>
        <Card sx={{ maxWidth: 500, width: "100%", boxShadow: 3 }}>
          <CardContent>
            <Typography variant="h4" gutterBottom>
              Admin Dashboard
            </Typography>
            <Typography variant="body1" color="text.secondary" gutterBottom>
              Welcome to the admin dashboard. Here you can get an overview of
              the platform, recent activity, and quick access to admin features.
            </Typography>
            <List>
              <ListItem>View platform statistics</ListItem>
              <ListItem>Access user management</ListItem>
              <ListItem>Review recent reports</ListItem>
              <ListItem>Change admin settings</ListItem>
            </List>
          </CardContent>
        </Card>
      </Box>
    </>
  );
};

export default AdminDashboard;
